"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ConversationsFull_1 = require("./components/ConversationsFull");
var ConversationsQuick_1 = require("./components/ConversationsQuick");
var isConversationsOptionDirty_1 = require("./utils/isConversationsOptionDirty");
var discardConversationsOption_1 = require("./actions/discardConversationsOption");
var saveConversationsOption_1 = require("./actions/saveConversationsOption");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var ConversationsOption = {
    key: 'conversations',
    titleStringKey: 'optionTitle_conversations',
    searchTermsStringKey: 'optionTitle_conversations',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ConversationsFull_1.default, null); },
        isDirty: isConversationsOptionDirty_1.default,
        onSave: saveConversationsOption_1.saveConversationsOptionFull,
        onDiscard: discardConversationsOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            render: function (props) { return (React.createElement(ConversationsQuick_1.default, tslib_1.__assign({}, props))); },
        },
        order: 1 /* Conversations */,
        workloads: 1 /* Mail */,
        customTitle: 'options_conversations_quick_label',
        tooltip: {
            tooltipStringKey: 'options_conversations_quick_tooltip',
            shouldHideTooltip: function () { return !owa_controls_feature_flags_1.isControlFeatureEnabled('tri-messageListView'); },
        },
    },
};
exports.default = ConversationsOption;
//# sourceMappingURL=ConversationsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/ConversationsOption.js
// module id = 5065
// module chunks = 2